import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeliveryRoutingModule } from './delivery-routing.module';
import { DeliveryComponent } from './delivery.component';
import { DeliveryFormComponent } from './delivery-form/delivery-form.component';
import { FormsModule } from '@angular/forms';
import { DeliveryViewComponent } from './delivery-view/delivery-view.component';
import { DeliveryCreateComponent } from './delivery-create/delivery-create.component';
import { DeliveryEditComponent } from './delivery-edit/delivery-edit.component';
import { DeliveryDetailsComponent } from './delivery-details/delivery-details.component';
import { AddressModule } from '../address/address.module';
import { MyCustomMaterialModule } from 'san-common';

@NgModule({
  declarations: [DeliveryComponent,
   DeliveryFormComponent,
   DeliveryCreateComponent,
   DeliveryViewComponent,
   DeliveryDetailsComponent,
   DeliveryEditComponent
  ],
  imports: [
    CommonModule,
    DeliveryRoutingModule,
    FormsModule,
    MyCustomMaterialModule,
    AddressModule
  ],
  exports: [DeliveryComponent,
    DeliveryFormComponent,
    DeliveryCreateComponent,
    DeliveryViewComponent,
    DeliveryDetailsComponent,
    DeliveryEditComponent
    
  ]
})
export class DeliveryModule { }
